import { useCallback, useEffect, useState } from "react";

const KEY = "oasis.tema";
type Tema = "light" | "dark";

function oku(): Tema {
  try {
    return localStorage.getItem(KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

/** Light varsayılan; sistem tercihi izlenmez (kullanıcı kararı). */
export function useTema() {
  const [tema, setTemaState] = useState<Tema>(oku);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", tema === "dark");
    document.querySelector('meta[name="theme-color"]')?.setAttribute("content", tema === "dark" ? "#0a141c" : "#f4f5f2");
  }, [tema]);

  const setTema = useCallback((t: Tema) => {
    setTemaState(t);
    try {
      localStorage.setItem(KEY, t);
    } catch {}
  }, []);

  return { tema, setTema, dark: tema === "dark" };
}
